<template>
  <delete-confirmation-modal
    ref="delete"
    :title="title"
    :text="text"
    :confirmMessage="confirmMessage"
    :hasExternalPopup="hasExternalPopup"
    @confirm="exclude"
    @cancel="cancel"
  />
</template>

<script>
export default {
  name: "ModalDelete",
  props: ["text", "show", "values", "title", "confirmMessage"],
  computed: {
    hasExternalPopup() {
      if (!this.values || !this.values.layouts || !Array.isArray(this.values.layouts)) return false;

      return this.values.layouts.some(
        layout => layout.external_popups && layout.external_popups.length > 0
      );
    }
  },
  watch: {
    show: function (value) {
      if (value) this.$refs.delete.open();
      else this.$refs.delete.close();
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel", this.values);
    },
    exclude() {
      this.$emit("exclude", this.values);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalDelete.vue